import { schema } from 'normalizr';

export const roleSchema = new schema.Entity('roles', {}, { idAttribute: 'RoleId' });

export const roleListSchema = [roleSchema];
